module.exports = __webpack_public_path__ + "static/flatart_ai_studio_header_05-491bbe8475c96145d8f002f0d9032263.webp";